<div class="status-badge" [class]="type"></div>
